import React, { useEffect, useRef, useState } from 'react';
import { CreditsSeries, Series, SeriesV2 } from 'frontend/types';
import Closed from './components/Closed/Closed';
import Open from './components/Open/Open';
import styles from './SeriesBanner.module.css';
export interface SeriesBannerProps {
  isSeriesPage?: boolean;
  series: Omit<Series, 'programs'> | SeriesV2 | CreditsSeries;
}
export const firstAndSecondSubjects = (subjectTree: string[][]): string[] => Array.from(new Set(subjectTree.reduce((acc, subjects) => [...acc, ...subjects.slice(0, 2)], [])));
const SeriesBanner = ({
  series,
  isSeriesPage = false
}: SeriesBannerProps) => {
  const {
    description,
    typicalAgeRangeTranslations,
    image,
    subjectTree,
    title,
    usp,
    version,
    allVersions,
    relations
  } = series;
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const hasMountedRef = useRef(false);
  useEffect(() => {
    if (hasMountedRef.current && buttonRef.current) {
      buttonRef.current.focus();
    }
    hasMountedRef.current = true;
  }, [isOpen]);
  const toggle = () => {
    setIsOpen(!isOpen);
  };
  const schoolSubjectsText = firstAndSecondSubjects(subjectTree).join(', ');
  const educationLevelsText = typicalAgeRangeTranslations.join(', ');
  return <div className={styles.wrapper} data-testid="series-banner-wrapper" data-sentry-component="SeriesBanner" data-sentry-source-file="SeriesBanner.tsx">
      <div className={styles.seriesBannerWrapper}>
        <div className={styles.innerWrapper}>
          {isOpen ? <Open description={description} educationLevels={educationLevelsText} images={image} ref={buttonRef} schoolSubjects={schoolSubjectsText} title={title} toggle={toggle} isSeriesPage={isSeriesPage} version={version} allVersions={allVersions} relations={relations} /> : <Closed educationLevels={educationLevelsText} images={image} ref={buttonRef} isSeriesPage={isSeriesPage} schoolSubjects={schoolSubjectsText} title={title} toggle={toggle} usp={usp} />}
        </div>
      </div>
    </div>;
};
export default SeriesBanner;